import type { SnakeCasedProperties } from '@frontend/duck-tape';
import type { AIQuestionnairePayload } from './tasks';

export const RECURRENCE_STREAM_TYPE_ENUM = {
  birthday: 'birthday',
  maintenance: 'maintenance',
  medical: 'medical',
  self_care: 'self_care',
} as const;

export type RecurrenceStreamType = (typeof RECURRENCE_STREAM_TYPE_ENUM)[keyof typeof RECURRENCE_STREAM_TYPE_ENUM];

export type RecurrenceInterval = 'day' | 'month' | 'week' | 'year';

export type SimpleRecurrenceState = 'active' | 'cancelled' | 'paused';

export type SimpleRecurrence = {
  createdAt: DateTimeISOString;
  description: string;
  id: string;
  nextTriggerAt: MaybeUndefined<DateTimeISOString>;
  ownerId: string;
  state: SimpleRecurrenceState;
  taskId: MaybeUndefined<string>;
  taskName: string;
};

export type RecurrenceSuggestionData = {
  birthdayDate?: MaybeUndefined<DateISOString>;
  // Can be a person/business/provider name
  entityName?: MaybeUndefined<string>;
  // Name/title of the task suggestion
  name?: MaybeUndefined<string>;
  type: RecurrenceStreamType;
};

export type CreateRecurrenceRequestPayload = {
  ai_questionnaire?: AIQuestionnairePayload;
  buffer: number;
  calendar_recurrence: MaybeUndefined<string>;
  calendar_recurrence_task_suggestion_idx: MaybeUndefined<number>;
  description: string;
  interval: RecurrenceInterval;
  interval_count: number;
  letter_recommendation?: {
    id: string;
    task_suggestion_idx: number;
  };
  name: string;
  proceed_decision: string;
  recurrence_prediction_id: MaybeUndefined<string>;
  // List of client IDs
  shared_with: string[];
  start_date: DateISOString;
  suggestion_data: MaybeUndefined<SnakeCasedProperties<RecurrenceSuggestionData>>;
};

export type ListRecurrencesResponse = SimpleRecurrence[];

export type RetrieveRecurrenceResponse = SimpleRecurrence;

export type ListRecurrencesParams = {
  suggestionType?: RecurrenceStreamType;
};
